module.exports = __webpack_public_path__ + "img/default_pic.b787bdd.jpg";